exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fix-chip{width:100px}.fix-chip .v-chip__content{text-align:center;margin:auto}\n", ""]);
